import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import { Col, Form, Row } from 'react-bootstrap';


export default function SetAdminSmsApiKey(props) {
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);

    
    const [apiKey, setApiKey] = useState("");

           
    
    const checkDataEntry = function(){
        if(apiKey.trim().length <36){
            setErrorMessage("کلید ارسال پیامک را وارد کنید");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const saveItem = function(){
      if(!checkDataEntry()) return;

      setSaving(true);
      
      var params = {login:util.getTrustedUser(), apiKey:apiKey};
      var url = config.Server+`/basic/sms/admin/set/api-key`;
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
 
                  setSaving(false);
                  setErrorMessage("با موفقيت ثبت گردید");
                  setErorVisible(true);
      
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
     }   
    
    return (
        <>
          
          <Row style={{marginTop:"20px"}} className='justify-content-center'>
            <Col md={4}>
              <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>ثبت کلید ارسال پیامک ادمین</div>
              <Row style={{padding:"5px", marginTop:"15px"}}>
                <Col>
                    <FloatLabel>
                      <InputText value={apiKey} onChange={(e) => setApiKey(e.target.value)} keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                      <label htmlFor="username">کلید ارسال پیامک</label>
                    </FloatLabel>
                </Col>
              </Row>
              <Row style={{padding:"5px", marginTop:"15px"}}>
                <Col md={6}>
                    <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                      <Button label="ثبت کلید ارسال پیامک" icon="pi pi-plus" onClick={()=>saveItem()} severity="secondary" iconPos="right" />                    
                    </div>
                </Col>
              </Row>
              <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
              <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
              <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
              <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
              <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
            </Col>
          </Row>
          <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
   
  }

 